interface IconBathProps {
  active?: boolean;
}
export const IconBath = ({ active }: IconBathProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1037_24943)">
        <g clipPath="url(#clip1_1037_24943)">
          <path
            d="M21.0664 9.67969H20.7316C20.7823 9.47 20.8086 9.25421 20.8086 9.03516C20.8086 7.49511 19.5557 6.24219 18.0156 6.24219C17.1791 6.24219 16.4042 6.6158 15.8806 7.24637C15.5978 7.15085 15.3032 7.10156 15.0078 7.10156C13.5401 7.10156 12.3341 8.23976 12.2239 9.67969H4.48047V3.79297C4.48047 2.96371 5.15512 2.28906 5.98438 2.28906H7.70312C8.05852 2.28906 8.34766 2.5782 8.34766 2.93359V3.22432C7.11742 3.51616 6.19922 4.62321 6.19922 5.94141V6.37109C6.19922 6.72705 6.4878 7.01562 6.84375 7.01562H11.1406C11.4966 7.01562 11.7852 6.72705 11.7852 6.37109V5.94141C11.7852 4.62321 10.867 3.51616 9.63672 3.22432V2.93359C9.63672 1.86741 8.76931 1 7.70312 1H5.98438C4.44433 1 3.19141 2.25293 3.19141 3.79297V9.67969H2.93359C1.86741 9.67969 1 10.5471 1 11.6133C1 12.4873 1.58309 13.2274 2.38059 13.4659L3.01639 20.4599C3.07964 21.1557 3.3986 21.7983 3.91448 22.2694C4.43041 22.7406 5.09926 23 5.79793 23H18.2021C18.9007 23 19.5696 22.7406 20.0855 22.2694C20.6014 21.7983 20.9204 21.1557 20.9836 20.4599L21.6194 13.4659C22.4169 13.2274 23 12.4873 23 11.6133C23 10.5471 22.1326 9.67969 21.0664 9.67969ZM10.4808 5.72656H7.50358C7.60816 4.99871 8.23585 4.4375 8.99219 4.4375C9.74852 4.4375 10.3762 4.99871 10.4808 5.72656ZM15.0078 8.39062C15.2756 8.39062 15.535 8.46509 15.7786 8.612C15.9315 8.70421 16.1158 8.72892 16.2876 8.68002C16.4594 8.63121 16.6032 8.51334 16.6848 8.35449C16.9455 7.84668 17.4555 7.53125 18.0156 7.53125C18.8449 7.53125 19.5195 8.2059 19.5195 9.03516C19.5195 9.25872 19.4678 9.4773 19.3683 9.67969H13.5195C13.6241 8.95188 14.2515 8.39062 15.0078 8.39062ZM19.6998 20.3432C19.6289 21.1229 18.985 21.7109 18.2021 21.7109H5.79793C5.01496 21.7109 4.37111 21.1229 4.30021 20.3432L3.68237 13.5469H20.3177L19.6998 20.3432ZM21.0664 12.2578H2.93359C2.5782 12.2578 2.28906 11.9687 2.28906 11.6133C2.28906 11.2579 2.5782 10.9688 2.93359 10.9688H21.0664C21.4218 10.9688 21.7109 11.2579 21.7109 11.6133C21.7109 11.9687 21.4218 12.2578 21.0664 12.2578Z"
            fill={active ? "#FF9934" : "#999999"}
          />
          <path
            d="M12 16.6621C10.7704 16.6621 9.85156 17.7964 9.85156 18.8105C9.85156 19.8386 10.7149 20.5293 12 20.5293C13.285 20.5293 14.1484 19.8386 14.1484 18.8105C14.1484 17.7964 13.2296 16.6621 12 16.6621ZM12 19.2402C11.912 19.2402 11.1406 19.2282 11.1406 18.8105C11.1406 18.4317 11.5453 17.9512 12 17.9512C12.4547 17.9512 12.8594 18.4317 12.8594 18.8105C12.8594 19.2282 12.088 19.2402 12 19.2402Z"
            fill={active ? "#FF9934" : "#999999"}
          />
          <path
            d="M12 15.8027C12.356 15.8027 12.6445 15.5142 12.6445 15.1582C12.6445 14.8022 12.356 14.5137 12 14.5137C11.644 14.5137 11.3555 14.8022 11.3555 15.1582C11.3555 15.5142 11.644 15.8027 12 15.8027Z"
            fill={active ? "#FF9934" : "#999999"}
          />
          <path
            d="M10.398 16.3078C10.6896 16.1036 10.7605 15.7017 10.5563 15.4102C10.3522 15.1186 9.95027 15.0477 9.65868 15.2519C9.3671 15.456 9.29624 15.8579 9.50039 16.1495C9.70453 16.4411 10.1064 16.512 10.398 16.3078Z"
            fill={active ? "#FF9934" : "#999999"}
          />
          <path
            d="M13.602 16.3078C13.8936 16.512 14.2955 16.4411 14.4997 16.1495C14.7039 15.8579 14.633 15.4561 14.3414 15.2519C14.0498 15.0477 13.6479 15.1186 13.4437 15.4102C13.2396 15.7018 13.3105 16.1036 13.602 16.3078Z"
            fill={active ? "#FF9934" : "#999999"}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1037_24943">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
        <clipPath id="clip1_1037_24943">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
